module.exports = __webpack_public_path__ + "static/media/globe.8e74c56a.jpg";